import { Table } from '@material-ui/core'
import { formatarData } from 'helpers/formatador'
import { Financeiro } from 'models/Viabilidade/Financeiro'
import NumberFormat from 'react-number-format'
import { TableContainerCustomizado, TableCellLabel, TableRowAlternada, TableCellValor } from '../index.style'
import { parsePorcentagem } from 'helpers/formatador'

const CartaoFinanceiro: React.FC<{ dados: Financeiro }> = ({ dados }) => {
  return (
    <TableContainerCustomizado>
      <Table data-cy="tableFinanceiro">
        <TableRowAlternada>
          <TableCellLabel>VPL</TableCellLabel>
          <TableCellValor data-cy="campoVpl">
            <NumberFormat value={dados.vpl} displayType="text" thousandSeparator="." decimalSeparator="," defaultValue="-"></NumberFormat>
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>RAU - VPL Anualizado (R$)</TableCellLabel>
          <TableCellValor data-cy="campoRauVplAnualizado">
            <NumberFormat value={dados.rauVplAnualizado} displayType="text" thousandSeparator="." decimalSeparator="," defaultValue="-"></NumberFormat>
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>RAU Unitário (R$/unid)</TableCellLabel>
          <TableCellValor data-cy="campoRauUnitario">
            <NumberFormat value={dados.rauUnitario} displayType="text" thousandSeparator="." decimalSeparator="," defaultValue="-"></NumberFormat>
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Exposição Máxima (R$)</TableCellLabel>
          <TableCellValor data-cy="campoExposicaoMaxima">
            <NumberFormat value={dados.exposicaoMaxima} displayType="text" thousandSeparator="." decimalSeparator="," defaultValue="-"></NumberFormat>
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Payback Compra (meses)</TableCellLabel>
          <TableCellValor data-cy="campoPaybackCompra">
            <NumberFormat value={dados.paybackCompra} displayType="text" thousandSeparator="." decimalSeparator="," defaultValue="-"></NumberFormat>
          </TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Payback Lançamento (meses)</TableCellLabel>
          <TableCellValor data-cy="campoPaybackLancamento">{dados.paybackLancamento}</TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Payback Mês da Virada (data)</TableCellLabel>
          <TableCellValor data-cy="campoPaybackMesVirada">{formatarData(dados.paybackMesVirada)}</TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>Duração do Projeto (meses)</TableCellLabel>
          <TableCellValor data-cy="campoDuracaoProjeto">{dados.duracaoProjeto}</TableCellValor>
        </TableRowAlternada>
        <TableRowAlternada>
          <TableCellLabel>TIR a.a (%)</TableCellLabel>
          <TableCellValor data-cy="campoTirAno">
            <NumberFormat
              value={parsePorcentagem(dados.tirAno as string)}
              displayType="text"
              decimalSeparator=","
              decimalScale={2}
              fixedDecimalScale={true}
              suffix="%"
              defaultValue="-"
            ></NumberFormat>
          </TableCellValor>
        </TableRowAlternada>
      </Table>
    </TableContainerCustomizado>
  )
}

export default CartaoFinanceiro
